import { useContext } from 'react';

import { AuthContext } from '../../shared/context/auth-context';
import { AccountProfile } from '../../types/models/user';
import { AccountDetailsRightMenu } from './accountDetails/AccountDetailsRightMenu';
import { RemindersRightMenu } from './children/RemindersRightMenu';
import { RemoveAccountRightMenu } from './children/RemoveAccountRightMenu';
import { TrackersRightMenu } from './children/TrackersRightMenu';
import { LanguagesRightMenu } from './languageDetails/LanguagesRightMenu';
import { ChangePasscodeRightMenu } from './securityDetails/ChangePasscodeRightMenu';
import { ChangePasswordRightMenu } from './securityDetails/ChangePasswordRightMenu';

type ProfileSettingsRightPanelProps = {
  activeMenu: { id: number };
  activeSubMenu: { id: number; title: string };
  profile: AccountProfile;
  isHidden: boolean;
  saveChanges: (profile: AccountProfile) => void;
  changeMenu: (arg0: number, arg1: string) => void;
};

export function ProfileSettingsRightPanel({
  activeMenu,
  activeSubMenu,
  profile,
  isHidden,
  saveChanges,
  changeMenu,
}: ProfileSettingsRightPanelProps) {
  const auth = useContext(AuthContext);
  const isNonSSOUser = auth.authType == null || auth.authType === 'ChampionHealth';

  return (
    <div className={`menu-right ${isHidden ? 'simplify' : ''}`}>
      {activeMenu?.id === 41 && (
        <>
          <AccountDetailsRightMenu
            hide={isHidden}
            changeMenu={changeMenu}
            profile={profile}
            saveChanges={saveChanges}
            activeSubMenuId={activeSubMenu?.id || 51}
          />
          <LanguagesRightMenu
            hide={isHidden}
            changeMenu={changeMenu}
            profile={profile}
            saveChanges={saveChanges}
            activeSubMenuId={activeSubMenu?.id || 57}
          />
          {isNonSSOUser && (
            <>
              <ChangePasswordRightMenu
                hide={isHidden}
                profile={profile}
                changeMenu={changeMenu}
                activeSubMenuId={activeSubMenu?.id || 52}
              />
              <ChangePasscodeRightMenu
                hide={isHidden}
                profile={profile}
                changeMenu={changeMenu}
                activeSubMenuId={activeSubMenu?.id || 53}
              />
            </>
          )}
        </>
      )}
      {activeMenu?.id === 41 && activeSubMenu?.id === 54 && (
        <RemoveAccountRightMenu hide={isHidden} changeMenu={changeMenu} />
      )}
      {activeMenu?.id === 43 && activeSubMenu?.id === 55 && (
        <RemindersRightMenu hide={isHidden} changeMenu={changeMenu} />
      )}
      {activeMenu?.id === 43 && activeSubMenu?.id === 56 && (
        <TrackersRightMenu hide={isHidden} changeMenu={changeMenu} />
      )}
    </div>
  );
}
